import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { A as CallToActionAnchor } from "components/CallToAction";
import { RenderHtmlAst } from "utils/render-html-ast";

const CareerOpeningWrapper = styled.div`
  padding-top: 8px;
`;

const StyledH2 = styled.h2`
  color: ${p => p.theme.colors.blueGrey};
  font-size: 16px;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 18px;
  }
  margin: 24px 0px 12px 0px;
  padding: 0;
  text-align: left;
  ${getFontFamily("regular")}
`;

const StyledUl = styled.ul`
  list-style: inside;
  margin: 0;
  padding: 0;
  text-align: left;
`;

const StyledLi = styled.li`
  font-size: 14px;
  margin: 16px 0px;
  padding: 0;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 16px;
  }
  :last-child {
    margin-bottom: 24px;
  }
  ${getFontFamily("book")}
`;

const StyledParagraph = styled.p`
  margin: 16px 0px;
  padding: 0;
  text-align: left;
  font-size: 14px;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 16px;
  }
  ${getFontFamily("book")}
`;

export function CareerOpening({
  career: {
    frontmatter: { url },
    htmlAst,
  },
}) {
  return (
    <CareerOpeningWrapper>
      <RenderHtmlAst
        components={{
          p: StyledParagraph,
          h2: StyledH2,
          li: StyledLi,
          ul: StyledUl,
        }}
        htmlAst={htmlAst}
      />
      <CallToActionAnchor
        css={`
          margin-top: 12px;
        `}
        href={url}
      >
        Apply Here
      </CallToActionAnchor>
    </CareerOpeningWrapper>
  );
}

CareerOpening.propTypes = {
  career: PropTypes.shape({
    frontmatter: PropTypes.object,
    htmlAst: PropTypes.object,
  }),
};
